import PropTypes from 'prop-types';
import React, { Fragment, useState } from "react";
import { FormGroup, InputGroup } from 'react-bootstrap';
import { AsyncTypeahead, Highlighter } from 'react-bootstrap-typeahead';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import { useTranslation } from 'react-i18next';
import { getPractitioners, getPractitionersExcludingMonitors } from '../../api/identity';
import '../../assets/sass/lbd/_asyncTypeahead.scss';
import { Search } from '../Icons/Icons';
import { HandleApiError } from "../Notifications/APIErrorHandler";
import { getPractitionersByProtocol } from '../../api/agenda';

export const PractitionerPicker = (props) => {
    const [isLoading, setIsLoading] = useState(false);
    const [options, setOptions] = useState([]);
    const { t } = useTranslation();

    const handleChange = value => {
        if (value.length > 0)
            props.onChange(props.name, props.multiple ? value : value[0]);
        else
            props.onChange(props.name, null);
    };

    const handleBlur = () => {
        if (props.onBlur)
            props.onBlur(props.name, true);
    };

    const onSearch = (query) => {
        setIsLoading(true);
        if (props.protocolId)
            getPractitionersByProtocol(props.protocolId, query, true, false)
                .then(response => {
                    setOptions(response?.data?.data.map(user => ({ fullName: user.fullName, fullNameUnique: user.fullName, userId: user.userId })));
                    setIsLoading(false);
                    //return response.data.data.map(user => ({ display: user.fullName, id: user.userId }))
                })
                .catch(error => {
                    setIsLoading(false);
                    setOptions([]);
                    HandleApiError(error);
                });
        else {
            const fetchFn = props.excludeMonitors ? getPractitionersExcludingMonitors : getPractitioners;
            fetchFn({
                pagination: {
                    sizePerPage: 100,
                },
                onlyDoctor: props.onlyDoctor,
                includeDisabled: props.includeDisabled,
                query: query
            })
                .then(response => {
                    const data = response.data?.data ?? [];
                    setOptions(data.map(user => ({
                        ...user,
                        fullNameUnique: user.fullNameUnique ?? user.fullName
                    })));
                    setIsLoading(false);
                })
                .catch(error => {
                    setIsLoading(false);
                    setOptions([]);
                    HandleApiError(error);
                });
        }

        //getPractitioners({
        //    pagination: {
        //sizePerPage: 100,
        //    },
        //    onlyDoctor: props.onlyDoctor,
        //    includeDisabled: props.includeDisabled,
        //    query: query
        //}).then(response => {
        //    console.log(response.data.data)
        //    setOptions(response.data.data);
        //    setIsLoading(false);
        //}).catch(error => {
        //    setIsLoading(false);
        //    setOptions([]);
        //    HandleApiError(error);
        //});
    };

    const renderMenuItemChildren = (option, { text }, index) => {
        return (
            <Fragment key={index}>
                <Highlighter search={text}>
                    {option.fullName}
                </Highlighter>
                <div>
                    <small>
                        {option.speciality && <div><b>{t("person.speciality")}:</b> <Highlighter search={text}>{option.speciality}</Highlighter></div>}
                        {option.registrationNumber && <div><b>{t("person.registrationNumber")}</b>: <Highlighter search={text}>{option.registrationNumber}</Highlighter></div>}
                    </small>
                </div>
            </Fragment>
        )
    };

    const sanitizedSelected = Array.isArray(props.selected)
        ? props.selected.filter(Boolean)
        : props.selected;

    const typeahead = (<AsyncTypeahead
        {...props}
        selected={sanitizedSelected}
        renderMenuItemChildren={renderMenuItemChildren}
        labelKey="fullNameUnique"
        filterBy={() => true}
        options={options}
        isLoading={isLoading}
        clearButton={true}
        highlightOnlyResult={true}
        allowNew={false}
        delay={1000}
        onSearch={onSearch}
        onChange={handleChange}
        onBlur={handleBlur}
    />);

    if (props.showSearchIcon)
        return (
            <FormGroup>
                <InputGroup>
                    <InputGroup.Addon><Search /></InputGroup.Addon>
                    {typeahead}
                </InputGroup>
            </FormGroup>
        );

    return typeahead;
}

PractitionerPicker.propTypes = {
    multiple: PropTypes.bool,
    onChange: PropTypes.func,
    minLength: PropTypes.number,
    protocolId: PropTypes.number,
    showSearchIcon: PropTypes.bool,
    onlyDoctor: PropTypes.bool,
    includeDisabled: PropTypes.bool,
    excludeMonitors: PropTypes.bool,
};

PractitionerPicker.defaultProps = {
    multiple: false,
    onChange: () => { },
    minLength: 2,
    showSearchIcon: false,
    onlyDoctor: false,
    includeDisabled: false,
    excludeMonitors: false
};